<template>
  <div class="modal-mask">
    <div class="modal-content-container">
      <div class="seller-groups__main-container">
        <div class="seller-groups__header-container">
          <span class="seller-groups__header-title">
            Gerenciar grupo(s) de vendedores
          </span>
          <span @click="closeDialog" class="material-icons seller-groups__closebtn-icon">
            cancel
          </span>
        </div>
        <div class="seller-groups__body-container">
          <div
            v-if="!myQuoteOnly"
            class="seller-groups__context-bar"
          >
            <div class="seller-groups__context-field">
              <label class="seller-groups__context-label">
                Comprador
              </label>

              <cc-select-v2
                class="seller-groups__buyer-select"
                :tracker="'usu_id'"
                :text="'usu_nome'"
                :options="buyers"
                :value="buyerFilter"
                placeholder="Selecione um comprador"
                @onselect="setBuyerFilter"
              />
            </div>
          </div>
          <cc-loader style="margin-top: 25vh" v-show="loading" />
          <div v-show="!loading" class="seller-groups__containers-wrapper">
            <div class="seller-groups__content-wrapper">
              <div class="seller-groups__title-wrapper">
                <span class="seller-groups__title">Meus Grupos</span>
                <cc-loader v-show="is_loading_request_sellers" />
              </div>
              <div class="seller-groups__input-wrapper">
                <input
                  placeholder="Digite o nome do Grupo"
                  class="seller-groups__input"
                  type="text"
                  v-model="new_group.nome"
                  @keyup.enter="create"
                />
                <span
                  @click="create"
                  style="color: #fff"
                  class="material-icons-outlined seller-groups__input-icon plus-icon"
                >
                  add
                </span>
              </div>
              <div class="seller-groups__table-container first-table">
                <table class="seller-groups__table-wrapper">
                  <thead class="seller-groups__table-thead">
                    <tr class="seller-groups__table-thead-tr">
                      <th class="seller-groups__table-th th-center">#ID</th>
                      <th class="seller-groups__table-th th-center">Nome</th>
                      <th class="seller-groups__table-th th-center">Ação</th>
                    </tr>
                  </thead>
                  <tbody class="seller-groups__table-tbody">
                    <tr
                      v-show="group.visible"
                      v-for="group in groups"
                      :key="group.id"
                      :class="{ selected: group.selected }"
                    >
                      <td class="seller-groups__table-td select-icon">
                        <i v-show="group.selected" class="fas fa-hand-point-right mr-2"></i
                        ><b>#{{ group.id }}</b>
                      </td>
                      <td v-if="group.selected" class="seller-groups__table-td table-input">
                        <cc-input v-model="group.nome" />
                      </td>
                      <td v-else class="seller-groups__table-td table-input">
                        <cc-input disabled v-model="group.nome" />
                      </td>
                      <td class="seller-groups__table-td">
                        <div class="seller-groups__table-td__icons-wrapper">
                          <span
                            v-if="!group.selected"
                            @click.stop="select_group(group)"
                            class="material-icons-outlined edit-icon"
                            >edit</span
                          >
                          <span
                            v-if="group.selected"
                            @click="update(group)"
                            class="material-icons-outlined save-icon"
                            >save</span
                          >
                          <span
                            class="material-icons-outlined trash-icon"
                            v-show="!group.loading"
                            @click.stop="remove_group(group)"
                            >delete</span
                          >
                          <cc-loader
                            v-show="group.loading"
                            :show_txt="false"
                            class="loader float-right"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="seller-groups__content-wrapper">
              <div class="seller-groups__title-wrapper">
                <span v-if="group.selected" class="seller-groups__title">{{
                  group.nome
                }}</span>
                <span v-if="!group.selected" class="seller-groups__title"
                  >Selecione um grupo</span
                >
              </div>
              <div class="seller-groups__input-wrapper">
                <input
                  placeholder="Digite o nome do Fornecedor"
                  class="seller-groups__input"
                  type="text"
                  @keyup.enter="group.selected && load_added_sellers()"
                  v-model="added_provider_name"
                  :disabled="!group.selected"
                />
                <span
                  @click="group.selected && load_added_sellers()"
                  style="color: #fff"
                  :class="{ disabled: !group.selected }"
                  class="material-icons-outlined seller-groups__input-icon plus-icon"
                >
                  search
                </span>
              </div>
              <div class="seller-groups__table-container middle-table first-table">
                <table class="seller-groups__table-wrapper">
                  <thead class="seller-groups__table-thead">
                    <tr class="seller-groups__table-thead-tr">
                      <th class="seller-groups__table-th">Fornecedor</th>
                      <th class="seller-groups__table-th">Vendedor</th>
                      <th class="seller-groups__table-th"></th>
                    </tr>
                  </thead>
                  <tbody class="seller-groups__table-tbody">
                    <tr
                      v-for="(seller, idx) in group_sellers"
                      :key="seller.usu_id"
                      :class="{ 'page-table-line-special': idx % 2 != 0 }"
                    >
                      <td class="seller-groups__table-td">
                        <b style="color: var(--primary-color)">{{
                          seller.provider.for_nome
                        }}</b>
                      </td>
                      <td class="seller-groups__table-td">{{ seller.usu_nome }}</td>
                      <td class="seller-groups__table-td">
                        <span
                          class="material-icons-outlined trash-icon"
                          v-show="!seller.loading"
                          @click.stop="remove_seller(seller)"
                          >delete</span
                        >
                        <cc-loader
                          style="width: 30px"
                          v-show="seller.loading"
                          :show_txt="false"
                          class="loader float-right"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="seller-groups__content-wrapper">
              <div class="seller-groups__title-wrapper">
                <span class="seller-groups__title">Fornecedores disponíveis</span>
                <cc-loader v-show="is_loading_available_sellers" />
              </div>
              <div class="seller-groups__input-wrapper">
                <input
                  placeholder="Digite o nome do Fornecedor"
                  class="seller-groups__input"
                  type="text"
                  @keyup.enter="load_sellers"
                  v-model="provider_name"
                />
                <span
                  @click="load_sellers"
                  style="color: #fff"
                  class="material-icons-outlined seller-groups__input-icon plus-icon"
                >
                  search
                </span>
              </div>
              <div class="seller-groups__table-container first-table">
                <table class="seller-groups__table-wrapper">
                  <thead class="seller-groups__table-thead">
                    <tr class="seller-groups__table-thead-tr">
                      <th class="seller-groups__table-th"></th>
                      <th class="seller-groups__table-th">Fornecedor</th>
                      <th class="seller-groups__table-th">Vendedor</th>
                    </tr>
                  </thead>
                  <tbody class="seller-groups__table-tbody">
                    <tr
                      v-for="(seller, idx) in sellers"
                      :key="seller.usu_id"
                      v-show="!seller.disabled"
                      :class="{
                        disabled: seller.disabled || !group.id,
                        'page-table-line-special': idx % 2 != 0,
                      }"
                    >
                      <td class="seller-groups__table-td">
                        <cc-loader
                          style="width: 30px"
                          v-show="seller.loading"
                          :show_txt="false"
                          class="loader float-right"
                        />
                        <span
                          v-show="
                            !seller.loading &&
                            seller.disabled != true &&
                            group.id &&
                            addBtnSelected
                          "
                          :class="{ disabled: seller.disabled }"
                          :disabled="seller.disabled"
                          @click.stop="add(seller)"
                          class="material-icons-outlined plus-icon"
                          >add</span
                        >
                      </td>
                      <td class="seller-groups__table-td">
                        <b style="color: var(--primary-color)">{{ seller.for_nome }}</b>
                      </td>
                      <td class="seller-groups__table-td">{{ seller.usu_nome }}</td>
                    </tr>
                    <tr v-if="filters.per_page <= filters.total_items">
                      <td colspan="3">
                        <div class="box-footer clearfix not-print">
                          <cc-pagination
                            :key="'pag'"
                            classes="orange"
                            :total="filters.total_items"
                            :page="page"
                            :page_limit="11"
                            :items_by_page_value="filters.per_page"
                            v-on:change="load_sellers($event)"
                          >
                          </cc-pagination>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>        
      </div>
    </div>
  </div>
  
</template>

<script>
import SellersService from "@/services/v2/sellers.service";
import RequestsService from "@/services/v2/requests.service";
import SellerGroupService from "@/services/v2/seller-group.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import QuotationService from "@/services/QuotationService";
import Pagination from "@/components/cliente/base-components/Pagination";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import { perm_mixin } from "@/mixins/permission.mixin";

export default {
  mixins: [loaderMixin, perm_mixin],
  props: {
    closeDialog: {
      type: Function,
    },
  },
  components: {
    ccPagination: Pagination,
  },
  data() {
    return {
      addBtnSelected: false,
      sellers: [],
      request_sellers: [],
      groups: [],
      group_sellers: [],
      group: {},
      new_group: {},
      page: 1,
      filters: {
        name: "",
        total_items: 0,
        per_page: 0,
      },
      loading: false,
      is_loading_available_sellers: false,
      is_loading_request_sellers: false,
      service: new SellersService(),
      group_svc: new SellerGroupService(),
      req_svc: new RequestsService(),
      quotation_service: new QuotationService(),
      modal: {
        title: `gerenciar grupos de vendedores`,
        subtitle: `Gerencie seus vendedores em grupos de acordo com suas necessidades`,
        icon_title: "fas fa-users",
        cancel_text: "Voltar",
        style: {
          width: "90%",
        },
      },
      provider_name: "",
      added_provider_name: "",
      buyers: [],
      buyerFilter: null,
      myQuoteOnly: false,
      loadingBuyers: false,
    };
  },
  methods: {
    update(group) {
      this.loading = true;
      this.group_svc
        .update(group)
        .then((response) => response.data)
        .then((data) => {
          this.load_groups({owner_id: this.buyer_id}).then(() => this.deactivate(data, this.groups));
          setTimeout(() => {
            this.load_sellers();
          }, 400);
        })
        .then((this.loading = false));
    },
    create() {
      if (!this.myQuoteOnly && this.buyer_id == null) {
        return console.log("Selecione um comprador");
      }
      const payload = {
        ...this.new_group
      };
      if (!this.myQuoteOnly && this.buyer_id != null) {
        payload.owner_id = this.buyer_id;
      }
      this.addBtnSelected = true;
      this.loading = true;
      this.group_svc
        .save(payload)
        .then((response) => response.data)
        .then((data) =>
          this.load_groups({owner_id: this.buyer_id}).then(() => this.toggle_activation(data, this.groups))
        )
        .then((this.loading = false))
        .then(() => {
          this.new_group = {};
          this.group_sellers = [];
          this.process_sellers();
          setTimeout(() => {
            this.load_sellers();
          }, 400);
        });
    },
    deactivate(group, collection) {
      this.addBtnSelected = false;
      collection.filter((s) => s.id !== group.id).forEach((s) => (s.selected = false));
      let g = collection.find((s) => s.id == group.id);
      g.selected = false;
      this.group_sellers = [];
      this.sellers = [];
      this.group = g;
      this.$forceUpdate();
    },
    toggle_activation(group, collection) {
      collection.filter((s) => s.id !== group.id).forEach((s) => (s.selected = false));
      let g = collection.find((s) => s.id == group.id);
      g.selected = true;
      this.group = g;
      this.$forceUpdate();
    },
    process_sellers() {
      this.sellers.forEach((gs) => (gs.disabled = false));
      this.sellers.forEach((s) => {
        this.group_sellers.forEach((gs) => {
          if (gs.usu_id == s.usu_id) {
            s.disabled = true;
          }
        });
      });
      this.$forceUpdate();
    },
    add(seller) {
      this.$set(seller, "loading", true);
      seller.provider = { for_nome: seller.for_nome };
      const payload = { seller_id: seller.usu_id }
      if (!this.myQuoteOnly && this.buyer_id != null) {
        payload.owner_id = this.buyer_id;
      }
      return this.group_svc
        .add_to_group(this.group.id, payload)
        .then(() => this.group_sellers.push(seller))
        .then(
          () => (this.sellers = this.sellers.filter((s) => s.usu_id != seller.usu_id))
        )
        .then(() => (this.group_sellers = this.order_group_sellers(this.group_sellers)))
        .then(() => this.$set(seller, "loading", false));
    },
    select_group(group) {
      this.addBtnSelected = true;
      this.loading = true;
      this.provider_name = "";
      const params = {};
      if (!this.myQuoteOnly && this.buyer_id != null) {
        params.owner_id = this.buyer_id;
      }
      return this.group_svc
        .load(group.id, params)
        .then((response) => response.data)
        .then((data) => {
          this.toggle_activation(data, this.groups);
          this.group_sellers = this.order_group_sellers(data.sellers);
          setTimeout(() => {
            this.load_sellers();
          }, 400);
          this.process_sellers();
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    remove_seller(seller) {
      this.$set(seller, "loading", true);
      seller.for_nome = seller.provider.for_nome;
      const params = { seller_id: seller.usu_id}
      if (!this.myQuoteOnly && this.buyer_id != null) {
        params.owner_id = this.buyer_id;
      }
      return this.group_svc
        .remove_from_group(this.group.id, params)
        .then(() => this.sellers.push(seller))
        .then(
          () =>
            (this.group_sellers = this.group_sellers.filter(
              (s) => s.usu_id != seller.usu_id
            ))
        )
        .then(() => this.sellers.forEach((s) => (s.provider = { for_nome: s.for_nome })))
        .then(() => (this.sellers = this.order_group_sellers(this.sellers)))
        .then(() => this.$set(seller, "loading", false))
        .then(() => this.$forceUpdate());
    },
    remove_group(group) {
      this.$set(group, "loading", true);
      const params = {};
      if (!this.myQuoteOnly && this.buyer_id != null) {
        params.owner_id = this.buyer_id;
      }
      return this.group_svc
        .remove(group.id, params)
        .then(() => {
          this.group = {};
          this.new_group = {};
          this.group_sellers = [];
          this.process_sellers();
          this.load_groups({owner_id: this.buyer_id}).then(() => this.deactivate(data, this.groups));
          setTimeout(() => {
            this.load_sellers();
          }, 400);
        })
        .then(() => this.$set(group, "loading", false));
    },
    close() {
      this.$emit("close");
    },
    load_sellers(page = this.page) {
      this.loading = true;
      return this.service
        .all({ page: page, provider_name: this.provider_name })
        .then((response) => response.data)
        .then((data) => {
          this.sellers = data.data;
          this.sellers.forEach((s) => (s.visible = true));
          this.filters.total_items = data.total;
          this.filters.per_page = data.per_page;
          this.process_sellers();
          this.loading = false;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    load_added_sellers(page = this.page) {
			this.present_loader("Carregando vendedores já no grupo...");
      const params = {search_name: this.added_provider_name};
      if (!this.myQuoteOnly && this.buyer_id != null) {
        params.owner_id = this.buyer_id;
      }
			return this.group_svc.load(this.group.id, params)
			.then(response => response.data)
			.then(data => {
				this.toggle_activation(data, this.groups);
				this.group_sellers = this.order_group_sellers(data.sellers);
				this.process_sellers()
				this.loading = false
        this.dismiss_loader()
			})
			.catch(error => {
				this.loading = false
				ErrorHandlerService.handle(error, this.$store);
			});
		},
    load_groups(params = {}) {
      this.loading = true;
      return this.group_svc
        .all(params)
        .then((response) => response.data)
        .then((data) => {
          this.groups = data;
          this.groups.forEach((s) => (s.visible = true));
          this.filters.total_group_items = data.total;
          this.loading = false;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    load_request_sellers() {
      this.loading = true;
      return this.req_svc
        .sellers_in(this.request.numeroCotacao)
        .then((response) => response.data)
        .then((data) => {
          this.loader_msg("Alocando vendedores...");
          this.request_sellers = data.data;
          this.request_sellers.forEach((s) => (s.visible = true));
          this.loading = false;
        })
        .catch((error) => {
          ErrorHandlerService.handle(error, this.$store);
        });
    },
    filter_sellers(collection, filter = "") {
      collection.forEach((s) => (s.visible = false));
      collection
        .filter(
          (s) =>
            s.usu_nome.toLowerCase().includes(filter.toLowerCase()) ||
            s.for_nome.toLowerCase().includes(filter.toLowerCase())
        )
        .forEach((s) => (s.visible = true));
      this.$forceUpdate();
    },
    order_group_sellers(sellers) {
      let result = sellers.sort(function (a, b) {
        if (a.provider.for_nome > b.provider.for_nome) {
          return 1;
        }
        if (a.provider.for_nome < b.provider.for_nome) {
          return -1;
        }
        return 0;
      });
      return result;
    },
    getBuyers() {
      this.loadingBuyers = true;
      this.quotation_service
        .getBuyers(localStorage.getItem("cli_id"))
        .then((response) => {
          this.buyers = response.data.usuarios.map(u => ({
            usu_id: u.usu_id,
            usu_nome: u.usu_nome || u.nome || u.usuario?.nome
          }));
          this.setDefaultBuyer();
        })
        .finally(() => {
          this.loadingBuyers = false;
        });
    },
    setDefaultBuyer() {
      const loggedUserId = Number(localStorage.getItem('usu_id'));
      if (!loggedUserId || !this.buyers.length) return;

      const buyer = this.buyers.find(
        b => Number(b.usu_id) === loggedUserId
      );

      if (buyer) {
        this.buyerFilter = buyer;
        this.setBuyerFilter(buyer);
      }
    },
    setBuyerFilter(selected) {
      this.new_group = {};
      this.group_sellers = [];
      this.process_sellers();
      if (!selected) {
        this.buyer_id = null;
        this.load_groups();
        return;
      }

      this.buyerFilter = selected;
      this.buyer_id = selected.usu_id;

      this.load_groups({
        owner_id: this.buyer_id
      });
    },
  },
  mounted() {    
    if (this.perms) {
      this.perms.forEach(p => {
        if (p.action === "READ" && p.resource === "MY_QUOTE") {
          this.myQuoteOnly = true;
        }
      });
    }
    if (this.myQuoteOnly) this.buyerFilter = { usu_id: localStorage.getItem("usu_id") };
    else this.getBuyers();
    this.load_groups();
    this.load_sellers();
  },
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
  -webkit-overflow-scrolling: touch;
}
.modal-content-container {
  background-color: white;
  width: 80vw;
  height: 80vh;
  border-radius: 12px;
  overflow: auto;
}
.seller-groups__main-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.seller-groups__header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-radius: 10px 10px 0px 0px;
  background-color: var(--primary-color);
}
.seller-groups__header-title {
  color: #ffffff;
  letter-spacing: -2%;
  font-weight: 500;
  font-size: 1.5em;
}
.seller-groups__closebtn-icon {
  color: #ffffff;
  font-size: 30px;
  cursor: pointer;
}
.seller-groups__containers-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
}
.seller-groups__content-wrapper {
  width: 25vw;
  border-radius: 8px;
  //-webkit-box-shadow: 1px 2px 6px 3px rgba(0,0,0,0.10);
  //box-shadow: 1px 2px 6px 3px rgba(0,0,0,0.10);
}
.seller-groups__title-wrapper {
  margin: 2px;
}
.seller-groups__title {
  color: #707070;
  font-weight: 400;
  font-size: 1.2rem !important;
}
.seller-groups__input-wrapper {
  margin: 5px 0px 10px 10px;
  display: flex;
  align-items: center;
  width: 34.8vw;
}
.seller-groups__input {
  width: 20vw;
  height: 5vh;
  border-top: 0.65px solid #e5e5e5;
  border-left: 0.65px solid #e5e5e5;
  border-bottom: 0.65px solid #e5e5e5;
  border-right: none;
  border-radius: 5.23px 0px 0px 5.23px;
  font-weight: 400;
  font-size: 0.8em;
  color: #a1a1a1;
}
.seller-groups__input:focus {
  outline: none !important;
  border: 0.65px solid var(--primary-color);
}
.seller-groups__input-icon {
  position: relative;
  left: -1.2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--primary-color);
  background-color: var(--primary-color);
  width: 4vw;
  height: 5vh;
  border-radius: 0px 5px 5px 0px;
  border-top: 0.65px solid #e5e5e5;
  border-bottom: 0.65px solid #e5e5e5;
  border-right: 0.65px solid #e5e5e5;
}
.seller-groups__table-container {
  margin: 20px 10px;
  overflow-y: auto;
  overflow-x: auto;
  max-height: 60vh;
}
.first-table {
  max-height: 38vh;
}
.seller-groups__table-wrapper {
}
.seller-groups__table-thead {
}
.seller-groups__table-thead-tr {
  background-color: #fffefc;
  border: 0.5px solid #e5e5e5;
  color: #605f5f;
  font-size: 1rem;
  font-weight: 400;
}
.seller-groups__table-th {
  font-family: Rubik;
  font-size: 1rem;
  font-weight: 600;
}
.seller-groups__table-tbody {
  border: 0.33px solid #e5e5e5;
}
.seller-groups__table-td {
  font-family: Rubik;
  color: #707070;
  font-size: 1rem !important;
  font-weight: 300;
}
.seller-groups__table-td__icons-wrapper {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.save-icon {
  color: var(--primary-color);
  cursor: pointer;
}
.edit-icon {
  color: #605f5f;
  cursor: pointer;
  margin-right: 5px;
}
.trash-icon {
  color: #cd2a2a;
  cursor: pointer;
}
.plus-icon {
  color: var(--primary-color);
  cursor: pointer;
}
.select-icon {
  color: var(--primary-color);
}
.selected {
  background-color: #f0f0f1;
}
.disabled {
  cursor: not-allowed !important;
}
.page-table-line-special {
  background: #f7f7f7;
}
.middle-table::-webkit-scrollbar {
  display: none; // Safari and Chrome
}
.seller-groups__context-bar {
  background-color: #fff;
  padding: 12px 10px;
  display: flex;
  align-items: center;
}

.seller-groups__context-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 280px;
}

.seller-groups__context-label {
  font-size: 13px;
  font-weight: 500;
  color: #707070;
}

.seller-groups__buyer-select {
  width: 100%;
}
.seller-groups__body-container {
  flex: 1;                 // ocupa todo espaço abaixo do header
  overflow-y: auto;        // scroll vertical interno
  overflow-x: hidden;      // evita scroll horizontal
  padding-bottom: 16px;
  padding-left: 16px;
  padding-right: 16px;
}

@media only screen and (min-width: 1440px) {
  .seller-groups__table-th {
    font-size: 20px;
  }
  .seller-groups__table-td {
    font-size: 20px;
  }
  .seller-groups__actions-title {
    font-size: 22px;
  }
  .seller-groups__title {
    font-size: 1.5em;
  }
  .seller-groups__input {
    font-size: 18px;
  }
}

@media only screen and (max-width: 750px) {
  .seller-groups__containers-wrapper {
    flex-direction: column;
    padding-bottom: 4px;
    margin: 10px 0px;
  }
  .seller-groups__main-container {
    overflow-y: auto;
  }
  .seller-groups__content-wrapper {
    width: 100vw;
    height: auto;
    margin: 7px;
  }
  .seller-groups__input-wrapper {
    width: 95vw;
  }
  .seller-groups__input-wrapper {
  }
  .seller-groups__input-icon {
    width: 15vw;
  }
  .seller-groups__input {
    width: 100vw;
  }
  .select-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    top: 10px;
  }
  .table-input {
    width: 40vw;
  }
  .th-center {
    text-align: center;
  }
}

@media only screen and (max-width: 500px) {
  .seller-groups__main-container {
    max-width: 110vw;
    padding-bottom: 20px;
    margin: 0 auto;
  }
}

@supports (-webkit-touch-callout: none) {
  .modal-mask {
    padding: 0;
    align-items: flex-start;
  }

  .modal-content-container {
    max-height: 100vh;
    border-radius: 0;
    width: 100vw;
    height: 100vh;
  }

  .seller-groups__containers-wrapper {
    height: 100%;
    overflow-y: auto;
  }
}

@import "./manage-seller-groups.modal";
</style>
